import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Instagram, Youtube, Shield, TrendingUp } from "lucide-react";

const columns = [
  {
    title: "Information",
    links: [
      ["Personal Loans", "/loans"],
      ["Business Loans", "/business-finance"],
      ["Mortgages", "/loans"],
      ["Auto Loans", "/loans"],
      ["Student Loans", "/loans"],
    ],
  },
  {
    title: "Areas of Focus",
    links: [
      ["Personal Finance", "/personal-finance"],
      ["Business Finance", "/business-finance"],
      ["Institutional Lending", "/institutional-lending"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/#about"],
      ["Contact", "/#contact"],
      ["FAQ", "/#faq"],
      ["Partners", "/#partners"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Notice", "/#faq"],
      ["Terms of Use", "/#faq"],
      ["Accessibility", "/#faq"],
      ["Cookie Notice", "/#faq"],
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#030A14] text-white pt-20 pb-10 mt-24 border-t border-white/5">
      {/* Prominent disclaimer bar at top of footer */}
      <div data-testid="site-disclaimer" className="absolute top-0 inset-x-0 bg-[#D4AF37]/10 border-b border-[#D4AF37]/30 text-[11px] font-mono text-[#D4AF37]/90 tracking-wide">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-2.5 text-center">
          Elevate Financial is not a bank · Not FDIC-insured · Not a credit application · Deposits are not accepted
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#1B63F0] to-[#071A35] flex items-center justify-center">
                <TrendingUp className="h-5 w-5 text-white" strokeWidth={2.6} />
              </div>
              <div>
                <div className="font-display font-bold text-xl">Elevate</div>
                <div className="text-[10px] font-mono uppercase tracking-[0.28em] text-[#D4AF37]">Financial</div>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Elevate Financial provides transparent lending information and refers interested consumers to trusted third-party partners. We are not a bank and do not accept deposits.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <Shield className="h-4 w-4 text-[#17A673]" />
              <span className="text-xs text-white/70 font-mono uppercase tracking-widest">Transparent · No Hidden Fees</span>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[Facebook, Twitter, Linkedin, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" data-testid={`social-${i}`} className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center hover:border-[#D4AF37]/60 hover:text-[#D4AF37] transition-colors">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <div className="ef-overline mb-4">{col.title}</div>
                <ul className="space-y-2.5">
                  {col.links.map(([label, to]) => (
                    <li key={label}>
                      <Link to={to} className="text-sm text-white/65 hover:text-white transition-colors">{label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5">
          <p className="text-xs text-white/50 leading-relaxed max-w-4xl">
            <strong className="text-white/80">Important:</strong> Elevate Financial is not a bank and does not accept deposits. Elevate Financial is not FDIC-insured. Information on this site is for general education only and is not a credit application, credit offer, or commitment to lend. All credit products described on this site are offered through third-party lending partners subject to their own underwriting, terms, and disclosures. Rates, terms, and eligibility vary and are not guaranteed. Consent to be contacted is not a condition of receiving any product or service.
          </p>
          <p className="text-xs text-white/50 mt-4">
            "Elevate Financial" and the "EF" symbol are trademarks used by this site.
          </p>
          <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/50">
            <div>© 2026 Elevate Financial. All rights reserved.</div>
            <div className="font-mono flex flex-wrap items-center gap-x-4 gap-y-1">
              <a href="mailto:hello@elevatefinancialloans.com" data-testid="footer-email" className="hover:text-[#D4AF37] transition-colors">hello@elevatefinancialloans.com</a>
              <span className="text-white/25">·</span>
              <a href="tel:+19042436944" data-testid="footer-phone" className="hover:text-[#D4AF37] transition-colors">Call us: +1 (904) 243-6944</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
